import "./App.scss";
import { ThemeProvider } from "@material-ui/core";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import theme from "./theme";
import { HttpClient } from "./web-services/http-client";
import { API_ENDPOINT } from "./web-services/api-endpoint";
import { LandingPage } from "./components/routes/landing-page";
import { ParkirAppBar } from "./components/common/parkir-app-bar";
import { ParkingLotsMapPage } from "./components/routes/parking-lots-map-page";
import { ParkingLotPage } from "./components/routes/parking-lot-page";
import { VjtPage } from "./components/routes/vjt-page";
import { VjtMapPage } from "./components/routes/vjt-map-page";
import { LoginPage } from "./components/routes/login-page";
import { HomePage } from "./components/routes/home-page";
import * as AuthService from "./web-services/auth-service";
import { FelhasznalokezeloPage } from "./components/routes/felhasznalokezelo-page";
// eslint-disable-next-line @typescript-eslint/naming-convention
function App()
{
    // We will later provider HttpClient for components as prop
    const httpClient = new HttpClient(API_ENDPOINT);
    const navigate = useNavigate();

    useEffect(() =>
    {
        const user = AuthService.getCurrentUser();

        if (user)
        {
            AuthService.authVeryify(navigate);
        }
    });


    return (
        <ThemeProvider theme={theme}>
            <div className="App">
                <ParkirAppBar
                    httpClient={httpClient}
                    userDisplayname=""
                    username=""
                    onLoginClick={() => navigate("/login")}
                    onOsszegzoButtonClick={() => navigate("/osszegzo")}
                    onTerkepButtonClick={() => navigate("/terkep")}
                    onKijelzoTerkepButtonClick={() => navigate("/kijelzoterkep")}
                    onKijelzokButtonClick={() => navigate("/kijelzok")}
                    onFelhasznalokButtonClick={() => navigate("/felhasznalok")}
                />
                <Routes>
                    <Route path="/" element={<HomePage httpClient={httpClient} />} />
                    <Route path="/login" element={<LoginPage httpClient={httpClient} />} />
                    <Route path="/osszegzo" element={<LandingPage httpClient={httpClient} />} />
                    <Route path="/terkep" element={<ParkingLotsMapPage httpClient={httpClient} />} />
                    <Route path="/kijelzoterkep" element={<VjtMapPage httpClient={httpClient} />} />
                    <Route path="/kijelzok" element={<VjtPage httpClient={httpClient} />} />
                    <Route path="/parking-lot/:id/:name" element={<ParkingLotPage httpClient={httpClient} />} />
                    <Route path="/felhasznalok" element={<FelhasznalokezeloPage httpClient={httpClient} />} />
                </Routes>
            </div>
        </ThemeProvider>
    );
}

export default App;
